import { format } from "date-fns";

import { type KomboJobState as KomboJobStateDto } from "../api";
import { Utility } from "./utility";

export interface KomboJobState extends KomboJobStateDto {}

export class KomboJobState extends Utility<KomboJobState> {
  constructor(init?: Partial<KomboJobStateDto>) {
    super();
    Object.assign(this, init);
  }

  get local_opened_at(): Date | null | undefined {
    if (this.opened_at === undefined) return undefined;
    if (this.opened_at === null) return null;
    return this.get_local_time(this.opened_at);
  }

  get local_opened_at_datetime_string(): string | null | undefined {
    if (this.local_opened_at === undefined) return undefined;
    if (this.local_opened_at === null) return null;
    return format(this.local_opened_at, "MMM d, hh:mm aaa");
  }

  query(query: string): boolean {
    return (
      this.name?.toLowerCase().includes(query.toLowerCase()) ||
      this.job_code?.toLowerCase().includes(query.toLowerCase()) ||
      this.location?.toLowerCase().includes(query.toLowerCase()) ||
      false
    );
  }
}
